export default {
  es: {
    auth: {
      forms: {
        labels: {
          firstName: 'Nombre propio',
          lastName: 'Apellido',
          username: "Nombre de usuario",
          email: 'Correo electrónico',
          phone: 'Introduzca un número de teléfono',
          accountType: 'Tipo de cuenta',
          password: 'Contraseña',
          confirmPassword: 'Confirmar Contraseña',
          agreeTerms: 'Estoy de acuerdo con los términos y el uso de Guio',
          signup: 'Inscribirse',
          cancel: 'Cancelar',
          submit: 'Enviar',
          forgotPassword: "Has olvidado tu contraseña",
          rememberMe: "Recuérdame",
          logIn: "Acceso",
          logInWithGoogle: "Iniciar sesión con Google",
          search: "Buscar"
        },
        errors: {
          firstName: 'Se requiere el primer nombre',
          username: 'Se requiere nombre de usuario',
          lastName: 'Se requiere apellido',
          emailMustBeValid: 'Debe ser válida correo electrónico',
          emailRequired: 'Se requiere correo electrónico',
          phone: 'El número de teléfono no es válido',
          accountType: 'Seleccione un tipo de cuenta',
          passwordRequired: 'Se requiere contraseña',
          passwordLength: 'La contraseña debe tener al menos 6 caracteres',
          confirmPasswordRequired: 'Se requiere confirmación de contraseña',
          confirmPasswordMatch: 'Las contraseñas deben coincidir',
          phoneRequired: "Se requiere el número de teléfono",
          phoneMinLength: "El número de teléfono debe tener al menos 7 dígitos",
          phoneMaxLength: "El número de teléfono debe tener al menos 15 dígitos",
          invalidNumber: "Solo se permiten dígitos"
        },
        validations: {
          invalidEmail: "Email inválido",
          emailRequired: "Email es requerido",
          passwordRequired: "Se requiere contraseña",
          selectAccountType: "Seleccione el tipo de cuenta"
        }
      },
      login: {
        welcome: "Bienvenida espalda!",
        pleaseLogin: "Por favor, ingrese a su cuenta.",
        firstTimeUser: "Usuario primerizo",
        rememberMe: "Recuérdame",
        forgotPassword: "Has olvidado tu contraseña",
      },
      signup: {
        signupSuccessMessage: 'Cuenta creada con éxito',
        sinupErrorMessage: '',
        pleaseComplete: 'Complete para crear su cuenta',
        or: 'O',
        signUpWithGoogle: 'Registrarse con Google',
        haveAnAccount: '¿Ya tienes una cuenta? Registrarse',
        termsOfUse: 'Condiciones de uso Política de privacidad',
        completeAccountTypeSetUp: 'Configuración completa de la cuenta,',
        byChoosingAccountType: 'Al elegir el tipo de cuenta',
        accountTypes: {
          mentor: 'Mentor',
          parent: 'Padre',
          mentee: 'Mentoreado'
        }
      },
      passwordReset:{
        passwordResetButton: "Enviar petición",
        passwordResetDescription: "Ingrese su correo electrónico y le enviaremos un enlace de restablecimiento de contraseña",
        checkEmail: 'Por favor revise su correo electrónico y haga clic en el enlace provisto para restablecer su contraseña.'
      },
    },
    dashboard:{
      nav: {
        dropDownMenu: {
          dashboard: "Tablero",
          dayMode: "Modo Día",
          nightMode: "Modo nocturno",
          logOut: "Cerrar sesión"
        },
        sideNavigationItems: {
          home: 'Casa',
          account: 'Cuenta',
          profile: 'Perfil',
          chat: 'Chat',
          kids: "Niñas",
          mentors:"Mentores",
          assessment: "Evaluación",
          sharedWithMe: 'Comparte conmigo',
          starred: 'Sembrado de estrellas',
          forums: {
            forums: 'Foros',
            home: 'Casa',
            exploreTopics: 'Temas del explorador',
            myTopics: 'Mis temas',
            myAnswers: 'Mis respuestas'
          }
        }
      },
      home: {
        message: 'Panel de inicio',
      },
      calendar: {
        today: "Hoy",
        day: "Día",
        week: "Semana",
        month: "Mes",
        fourDays: "4 dias",
        close: "Cerca",
        view: "Vista",
        createdBy: "Creado por",
        date: "Dafechate",
        duration: "Duración",
        description: "Descripción",
        type: "Tipo",
        nature: "Naturaleza",
        link: "Enlance",
        participants: "Los participantes",
        minutes: "Minutos",
        none: "Ninguno",
        public: "Público",
        closed: "Cerrado",
        video: "Video",
        notVideo: "No Video"
      },
      kids: {
        noKidsCreated: "Aún no has añadido un niño.",
        title: {
          myKids: "Mis hijas",
        },
        added: "Agregado",
        buttons: {
          back: "Atrás",
          cancel: "Cancelar",
          continue: "Seguir",
          addNew: "Añadir Nueva",
          edit: "Editar",
          delete: 'Borrar'
        },
        stepForm: {
          personalInformation: "Informacion personal",
          security: "Seguridad"
        }
      },
      assessments: {
        buttons: {
          submit: "Enviar",
          next: "Próxima",
          begin: "Empezar",
          continue: "Aceptar y continuar",
          exit: "Salida",
          finish: "Terminar"
        },
        completed: "Terminada",
        submitedModal: {
          title: "Evaluación completada",
          body: "Guiomentor lo felicita por terminar su evaluación de {assessmentTitle}"
        },
        table: {
          headers: {
            name: "Nombre",
            level: "Nivel",
            numberOfQuestions: "Numero de preguntas",
            time: "Hora",
            category: "Categoría",
            take: "Llevar"
          },
          loadingText: "Cargando por favor espere",
          noDataText: "No hay evaluaciones disponibles",
          assessmentsPerPage: "evaluaciones por página"
        },
        instructions: {
          title: "Antes de comenzar la evaluación, debe aceptar los siguientes términos.",
          terms: {
            answering: "Las preguntas de esta evaluación están en formato de opción múltiple, elija su mejor opción.",
            nextAction: "Para enviar una pregunta respondida, haga clic en el botón siguiente y en el botón finalizar si fue la última pregunta.",
            noGoingBack: "Una vez que una pregunta respondida y enviada no se puede editar.",
            timer: "El temporizador muestra el tiempo que llevará la evaluación y realiza una cuenta regresiva a medida que avanza el proceso de respuesta.",
            finishAssessment: "Todas las preguntas deben ser respondidas, de modo que esta evaluación sea etiquetada como completa.",
          },
          noAgreement: "No estuvo de acuerdo con las instrucciones de la evaluación."
        },
        assessmentBackDialog:{
          confirm: "Confirmar acción",
          backMessage: "¿Está seguro de que desea volver ?, su evaluación finalizará",
          cancel: "Cancelar",
          back: "atrás"
        },
        timer: {
          seconds: "Segundos",
          minutes: "Minutos",
          hours: "Horas"
        },
        timeUpDialog: {
          timeUp:"¡El tiempo ha terminado!",
          timeUpMessage:"Tu sesión ha terminado"
        }
      },
      logOutDialog:{
        logOutConfirm: "Confirmar Cerrar sesión",
        logOutMessage: "¿Está seguro de que desea cerrar sesión?",
        cancel: "Cancelar",
        logOut: "Cerrar sesión"       
      },
      mentors:{
        book: "Sesión de libro",
        appointmentCard:{
          title: "Reservar una cita",
          date:"Fecha de nombramiento",
          time:"Elija hora",
          duration: "Duración (minutos)",
          description: "Descripción",
          cancel:"Cancelar",
          confirm: "Confirmar",
          successMessage:"Se ha fijado una cita con su mentor.",
          errors:{
            durationNotNegative: "La duración no puede ser negativa",
            durationRequired: "Se requiere duración",
            descriptionLimit: "La descripción no debe exceder los 500 caracteres",
            descriptionRequired: "La descripción es obligatoria",
            dateRequired: "La fecha es obligatoria",
            meetingTime: "Se requiere tiempo de reunión"
          }
        }
      }
    },
    profile: {
      nav: {
        profile: 'Perfil',
        notifications: 'Notificación',
        favorites: 'Favoritos',
        passwordAndSecurity: 'Contraseña y seguridad'
      },
      edit: {
        title: 'Editar perfil',
        deleteMyAccount: 'Eliminar esta cuenta',
        hello: 'Hola',
        byDeleting: 'Al eliminar esta cuenta, se borrarán todos los datos del usuario, los chats relacionados, las publicaciones y todas las respuestas.',
        deleteConfirmation: '¿Estás seguro de que quieres eliminar esta cuenta?',
        deleteSuccess: 'Perfil eliminado correctamente',
        updatedSuccess: 'Tu perfil fue actualizado',
        forms: {
          labels: {
            userName: 'Nombre de usuario',
            dateOfBirth: 'Fecha de nacimiento',
            country: 'País',
            save: 'Guardar cambios',
            deleteAccount: 'Borrar cuenta',
            delete: 'Borrar'
          },
          errors: {
            dateOfBirth: 'Se requiere cumpleaños',
            country: 'El país es obligatorio'
          }
        },
        fileUploadError: "No pudimos subir tu avatar. Inténtalo de nuevo",
        fileSizeLimit: "Imagen demasiado grande Seleccione un archivo de menos de 1 MB."
      },
      passwordChange: {
        labels: {
          passwordChangeTitle: "cambio Contraseña",
          currentPassword: "Actual Contraseña",
          newPassword: "Nueva Contraseña",
          confirmPassword: "Confirmar Contraseña",
          passwordChangeButton: "cambio Contraseña"
        },
        changePasswordAlert: "Contraseña cambiada con éxito. Esto tendrá efecto en su próximo inicio de sesión.",
        errors: {
          currentPasswordRequired: "Actual Contraseña se requiere",
          currentPasswordCharacters: "Actual Contraseña debe tener al menos 6 caracteres larga",
          newPasswordRequired: "Nueva Contraseña se requiere",
          newpasswordCharacters: "Nueva Contraseña debe tener al menos 6 caracteres larga",
          passwordConfirmation: "Contraseña confirmación se requiere",
          passwordMatch: "Las contraseñas deben coincidir",
          ChangeNotSuccessfull: "Cambio de contraseña fallido"
        }
      }
    },
    passwordChange:{
      labels:{
      passwordChangeTitle: "cambio Contraseña",
      currentPassword: "Actual Contraseña",
      newPassword: "Nueva Contraseña",
      confirmPassword: "Confirmar Contraseña",
      passwordChangeButton: "cambio Contraseña"
      },
        changePasswordAlert: "Contraseña cambiada con éxito. Esto tendrá efecto en su próximo inicio de sesión.",
      errors: {
        currentPasswordRequired: "Actual Contraseña se requiere",
        currentPasswordCharacters: "Actual Contraseña debe tener al menos 6 caracteres larga",
        newPasswordRequired: "Nueva Contraseña se requiere",
        newpasswordCharacters: "Nueva Contraseña debe tener al menos 6 caracteres larga",
        passwordConfirmation: "Contraseña confirmación se requiere",
        passwordMatch: "Las contraseñas deben coincidir"
      }
    },
    snackbar: {
      close: "Cerca"
    },
    notFound: {
      pageNotFound: "Página no encontrada",
      oops: "Huy! Algo salió mal",
      pageUnavailable: "Es posible que se haya eliminado la página que está buscando o que no esté disponible temporalmente",
      goBack: "Regresa...",
      serverError: "Algo salió mal en el servidor"
    },
    errors: {
      somethingWentWrongError: 'Algo salió mal',
      weCouldNotGetProfile: "No pudimos obtener tu perfil. Vuelva a cargar la ventana para volver a intentarlo",
      emailTaken: "El Correo electrónico  {email} ya está en uso.",
      usernameTaken: "El Nombre de usuario {username} ya está en uso.",
      emailAndUsernameTaken: "El Correo electrónico {email} y el Nombre de usuario {username} ya están en uso.",
      noPermissions: ":( Lo sentimos, no tiene los permisos para acceder a esta página."
    },
    internetBanner:{
      onlineMessage:"De nuevo en línea",
      offlineMessage:"Sin conexión a Internet"
    },
    events: {
      eventInformation: "Información del Evento",
      participants: "Las participantes",
      eventName: "Nombre del evento",
      duration: "Duración",
      minutes: "Minutos",
      numberOfParticipants: "Número de participantes",
      publicEvent: "Evento público",
      eventLink: "Enlace de evento",
      date: "Fecha",
      time: "Hora",
      confirmDelete:{
        confirm:"¿Estás seguro de que quieres eliminar este evento?",
        title:"¿Eliminar este evento?",
        delete:"Borrar",
        cancel: "Cancelar"
      },
      editCard:{
        title: "Editar evento",
        date:"Fecha de nombramiento",
        time:"Elija hora",
        duration: "Duración (minutos)",
        description: "Descripción",
        cancel:"Cancelar",
        save: "salvar",
        successMessage:"Evento editado con éxito",
        errors:{
          durationLimit: "La duración debe ser al menos 15",
          durationRequired: "Se requiere duración",
          descriptionLimit: "La descripción no debe exceder los 500 caracteres",
          descriptionRequired: "La descripción es obligatoria",
          dateRequired: "La fecha es obligatoria",
          timeRequired: "Se requiere tiempo"
        }
      },
      success: {
        deleteEvent: "Evento eliminado correctamente"
      }
    }
  }
}
